<div [ngClass]="{ wrap: wrapContent }">
  <div class="soap-print-header print-header">
    @if (!payload?.properties?.hideLabel?.value && payload?.properties?.text?.value) {
      <div class="header">
        <div class="title">
          <span [innerHTML]="payload?.properties?.text?.value | tokenToDiv"></span>
          @if (payload?.properties?.required?.value) {
            <span class="required-asterisk">*</span>
          }
        </div>
        <span class="message">* populated from PatientNow</span>
      </div>
    }

    @if (payload?.properties?.content?.value) {
      <div class="flex flex-row">
        <div class="flex word-wrap mb10">
          <div class="flex subtitle">
            <span [innerHTML]="payload?.properties?.content?.value | tokenToDiv"></span>
          </div>
        </div>
      </div>
    }

    <mat-divider></mat-divider>
  </div>

  <form class="soap-form" [formGroup]="soapForm">
    <div class="soap-container">
      @if (!isPrinting || hasSectionData('subjective')) {
        <fb-soap-input-list
          label="Subjective Note"
          [fields]="subjectiveFields"
          [readonly]="isDesign || isPrinting || isSubmitted || isPreview || isEmrReadonly"
          [expanded]="isSectionExpanded('subjective')"
          [printMode]="isPrinting"
          [showEmptyRowsInPrint]="isTemplatePrint"
          formControlName="subjective"
          [assignedAttributes]="subjectiveAttributes"
          [assignedAttributesDisplay]="subjectiveAttributeLabels"
          [sectionMarkerTarget]="soapMarkerTarget"
          [rowMarkerTargets]="getSectionMarkerTargets('subjective')"
          attributesMarkerKey="subjectiveAttributes"
          amendmentSection="subjective"
          (assignedAttributesChange)="onAttributesChanged('subjective', $event)"
          (addAttributeAction)="openAddAttributeDialog('subjective')"
          [employees$]="employees$"
          addButtonText="Subjective Note"
          [hideActionButtons]="isEmrReadonly"
          [autoDate]="defaultDateValue"
          [autoEmployeeId]="defaultEmployeeId"
          [lockDateEmployee]="isFillAndSignMode"
        ></fb-soap-input-list>
      }

      @if (!isPrinting || hasSectionData('objective')) {
        <fb-soap-input-list
          label="Objective Note"
          [fields]="objectiveFields"
          [readonly]="isDesign || isPrinting || isSubmitted || isPreview || isEmrReadonly"
          [expanded]="isSectionExpanded('objective')"
          [printMode]="isPrinting"
          [showEmptyRowsInPrint]="isTemplatePrint"
          formControlName="objective"
          [assignedAttributes]="objectiveAttributes"
          [assignedAttributesDisplay]="objectiveAttributeLabels"
          [sectionMarkerTarget]="soapMarkerTarget"
          [rowMarkerTargets]="getSectionMarkerTargets('objective')"
          attributesMarkerKey="objectiveAttributes"
          amendmentSection="objective"
          (assignedAttributesChange)="onAttributesChanged('objective', $event)"
          (addAttributeAction)="openAddAttributeDialog('objective')"
          [employees$]="employees$"
          addButtonText="Objective Note"
          [hideActionButtons]="isEmrReadonly"
          [autoDate]="defaultDateValue"
          [autoEmployeeId]="defaultEmployeeId"
          [lockDateEmployee]="isFillAndSignMode"
        ></fb-soap-input-list>
      }

      @if (!isPrinting || hasSectionData('assessment')) {
        <fb-soap-input-list
          label="Assessment Note"
          [fields]="assessmentFields"
          [readonly]="isDesign || isPrinting || isSubmitted || isPreview || isEmrReadonly"
          [expanded]="isSectionExpanded('assessment')"
          [printMode]="isPrinting"
          [showEmptyRowsInPrint]="isTemplatePrint"
          formControlName="assessment"
          [assignedAttributes]="assessmentAttributes"
          [assignedAttributesDisplay]="assessmentAttributeLabels"
          [sectionMarkerTarget]="soapMarkerTarget"
          [rowMarkerTargets]="getSectionMarkerTargets('assessment')"
          attributesMarkerKey="assessmentAttributes"
          amendmentSection="assessment"
          (assignedAttributesChange)="onAttributesChanged('assessment', $event)"
          (addAttributeAction)="openAddAttributeDialog('assessment')"
          [employees$]="employees$"
          addButtonText="Assessment Note"
          [hideActionButtons]="isEmrReadonly"
          [autoDate]="defaultDateValue"
          [autoEmployeeId]="defaultEmployeeId"
          [lockDateEmployee]="isFillAndSignMode"
        ></fb-soap-input-list>
      }

      @if (!isPrinting || hasSectionData('plan')) {
        <fb-soap-input-list
          label="Plan Note"
          [fields]="planFields"
          [readonly]="isDesign || isPrinting || isSubmitted || isPreview || isEmrReadonly"
          [expanded]="isSectionExpanded('plan')"
          [printMode]="isPrinting"
          [showEmptyRowsInPrint]="isTemplatePrint"
          formControlName="plan"
          [assignedAttributes]="planAttributes"
          [assignedAttributesDisplay]="planAttributeLabels"
          [sectionMarkerTarget]="soapMarkerTarget"
          [rowMarkerTargets]="getSectionMarkerTargets('plan')"
          attributesMarkerKey="planAttributes"
          amendmentSection="plan"
          (assignedAttributesChange)="onAttributesChanged('plan', $event)"
          (addAttributeAction)="openAddAttributeDialog('plan')"
          [planItems]="planItems"
          [planItemsQuantity]="planItemsQuantity"
          [employees$]="employees$"
          addButtonText="Plan Note"
          [hideActionButtons]="isEmrReadonly"
          [autoDate]="defaultDateValue"
          [autoEmployeeId]="defaultEmployeeId"
          [lockDateEmployee]="isFillAndSignMode"
          [showExtraButton]="true"
          extraButtonText="Add Plan Items"
          (extraAction)="openPlanItemsDialog()"
        ></fb-soap-input-list>
      }
    </div>
  </form>

  @if (isEmrReadonly) {
    <fb-emr-readonly-notice />
  }

  @if (payload?.properties?.hint?.value) {
    <div class="hint" [innerHTML]="payload?.properties?.hint?.value | tokenToDiv"></div>
  }

  @if (payload?.properties?.required?.value && isSubmitted && !isValid()) {
    <div class="hint-required">This field is required</div>
  }
</div>
